import React from "react";
import { cn } from "@agnes/ui";
import { Check } from "lucide-react";
import { BaseComponentProps } from "@/components/BaseComponentProps";

const ETAPAS_ACAO_EM_MASSA = [
  { titulo: "Relação de Rubricas", subtitulo: "Dados a serem alterados" },
  { titulo: "Campos afetados", subtitulo: "Escopo das alterações" },
  { titulo: "Revisão", subtitulo: "Conferência de dados" },
];

export interface StepperAcaoEmMassaProps extends BaseComponentProps {
  /** Índice da etapa atual (0 a 2). */
  atual: number;
}

export function StepperAcaoEmMassa({
  atual,
  dataQa = "acao-massa-etapas",
}: StepperAcaoEmMassaProps) {
  return (
    <ol data-qa={dataQa} className="mx-auto my-6 flex max-w-3xl items-start justify-center">
      {ETAPAS_ACAO_EM_MASSA.map((etapa, index) => {
        const concluida = index < atual;
        const corrente = index === atual;
        return (
          <React.Fragment key={etapa.titulo}>
            <li
              data-qa={`${dataQa}-${index + 1}`}
              aria-current={corrente ? "step" : undefined}
              className="flex w-40 flex-col items-center gap-2 text-center"
            >
              <span
                className={cn(
                  "flex h-12 w-12 items-center justify-center rounded-full text-lg font-bold",
                  concluida || corrente
                    ? "bg-agnes-primary text-white"
                    : "bg-agnes-primary-light text-agnes-primary",
                  corrente && "shadow-agnes-panel",
                )}
              >
                {concluida ? <Check aria-label="Concluída" className="h-5 w-5" /> : index + 1}
              </span>
              <span
                className={cn(
                  "text-sm font-semibold",
                  concluida || corrente ? "text-agnes-text-primary" : "text-agnes-text-muted",
                )}
              >
                {etapa.titulo}
              </span>
              <span className="text-xs text-agnes-text-muted">{etapa.subtitulo}</span>
            </li>
            {index < ETAPAS_ACAO_EM_MASSA.length - 1 && (
              <li
                aria-hidden="true"
                className={cn(
                  "mt-6 h-[3px] w-20 shrink-0 rounded-full",
                  concluida ? "bg-agnes-primary" : "bg-agnes-primary-light",
                )}
              />
            )}
          </React.Fragment>
        );
      })}
    </ol>
  );
}
